import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Hook to get the current page number
 */
function usePageNumber(defaultPage = 1) {
  const location = useLocation();

  const pageNumber = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = Number(queryParams.get('pageNumber'));
    console.log(page, 'page');
    return isNaN(page) || page < 1 ? defaultPage : page;
  }, [location.search, defaultPage]);

  return pageNumber;
}

/**
 * Hook to get the current page size
 */
function usePageSize(defaultSize = 10) {
  const location = useLocation();

  const pageSize = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const size = Number(queryParams.get('pageSize'));
    console.log(size, 'size');
    return isNaN(size) || size < 1 ? defaultSize : size;
  }, [location.search, defaultSize]);

  return pageSize;
}

/**
 * Hook to set both page number and/or page size in the URL
 */
function useSetPagination() {
  const location = useLocation();
  const navigate = useNavigate();

  const setPagination = (pageNumber, pageSize) => {
    const params = new URLSearchParams(location.search);
    if (pageNumber !== undefined) params.set('pageNumber', pageNumber);
    if (pageSize !== undefined) params.set('pageSize', pageSize);

    navigate(
      {
        pathname: location.pathname,
        search: params.toString(),
      },
      { replace: true },
    );
  };

  return setPagination;
}

/**
 * Backward-compatible functions (optional)
 */
function useSetPageNumber() {
  const setPagination = useSetPagination();
  return (pageNumber) => setPagination(pageNumber);
}

function useSetPageSize() {
  const setPagination = useSetPagination();
  return (pageSize) => setPagination(undefined, pageSize);
}

export {
  usePageNumber,
  usePageSize,
  useSetPageNumber,
  useSetPageSize,
  useSetPagination,
};
